<template>
<div class="page_order page page_goodsUp">
    <van-tabs v-model="active" swipe-threshold="2" @click="onTabsClick">
        <van-tab title="在售"></van-tab>
        <van-tab title="下架"></van-tab>
    </van-tabs>
    <!-- <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
    </van-list> -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
            <div class="list">
                <div class="item" v-for="goods in goodsList" :key="goods.good_id">
                    <!-- 左侧按钮 -->
                    <div class="item_left">
                        <div class="select_box">
                            <van-checkbox v-model="goods.checked" @click="checkGood(goods)">
                                <template #icon="props">
                                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon">
                                </template>
                            </van-checkbox>
                        </div>
                    </div>
                    <!-- 右侧 -->
                    <div class="item_right">
                        <div class="item_right_l">
                            <!-- <img :src="publicPath+'statics/images/temp/tu01.png'" alt="" class="tu"> -->
                            <img :src="imageUrl+goods.good_thumb" alt="" class="tu">
                        </div>
                        <div class="item_right_r">
                            <div class="item_right_r_t">
                                <div class="title slh_s">{{ goods.good_title }}</div>
                                <div class="store">
                                    <span class="yishou">已售{{ goods.sales }}</span>
                                    <span class="kucun">库存{{ goods.store }}</span>
                                </div>
                                <div class="jinjia">平台进价：￥{{ goods.platprice }}</div>
                            </div>
                            <div class="item_right_r_b">
                                <div class="price">
                                    <span class="tag_cash">¥</span>
                                    <span class="">{{ goods.good_price }}</span>
                                </div>
                                <div class="actions">
                                    <div class="action" v-if="active==0" @click="dropGoods(goods)">下架</div>
                                    <!-- <div class="action" v-else @click="onGoods(goods)">上架</div> -->
                                    <div class="action" v-else @click="onUpSingleGoods(goods)">上架</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 批量下架 -->
                <div class="item piliang">
                    <div class="item_left">
                        <div class="select_box">
                            <van-checkbox v-model="checkedAll" @click="clickAllCheck">
                                <template #icon="props">
                                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon">
                                </template>
                            </van-checkbox>
                        </div>
                    </div>
                    <div class="item_title" v-if="active == 0">批量下架</div>
                    <div class="item_title" v-else>批量上架</div>
                </div>
                <div class="big_btn" v-if="active == 0" @click="dropAllGoods">下架</div>
                <!-- <div class="big_btn" v-else @click="onAllGoods">上架</div> -->
                <div class="big_btn" v-else @click="onUpAllGoods">上架</div>
            </div>
        </van-list>
    </van-pull-refresh>
    
    <!-- 上架时间 -->
    <van-dialog v-model="show" class="dialog" show-cancel-button @confirm="confirmOnGoods" @cancle="show = false">
        <div class="title">请选择时间</div>
        <van-cell-group>
            <van-field v-model="starttime" label="上架时间" placeholder="请选择上架时间" readonly @click="onTimepicker(0)" />
            <van-field v-model="endtime" label="下架时间" placeholder="请选择下架时间" readonly @click="onTimepicker(1)" />
        </van-cell-group>
    </van-dialog>
    <!-- 时间选择 -->
    <van-popup v-model="timepicker" position="bottom">
        <van-datetime-picker v-model="currentDate" type="datetime" title="选择时间" :min-date="minDate" @confirm="confirmTime" @cancel="timepicker=false" />
    </van-popup>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            active: 0,
            goodsList: [],
            token: '',
            activeIcon: process.env.BASE_URL + './statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + './statics/images/inactive.png',
            checked: true,
            checkedAll: true,
            show: false, // 时间选择弹层
            timepicker: false, // 时间插件pop层
            starttime: '',
            endtime: '',
            currentDate: new Date(),
            minDate: new Date(),
            timeType: 0, // 0 上架时间 1下架时间
            goods: null, // 转存单个商品数据
            goods_tag: 0, // 0 单个上架 1批量上架
            finished: false,
            page: 1,
            size: 10,
            loading: false,
            refreshing: false,
        };
    },
    created: function () {
        if (this.$route.query.status) {
            this.active = this.$route.query.status
        }
    },
    mounted: function () {

        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '商品管理',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.onRefresh()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.onRefresh()
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            // 获取列表
            this.onRefresh();
        }

    },
    methods: {
        onTabsClick(name, title) {
            this.active = name;
            this.goodsList = [];
            this.page = 1;
            this.onRefresh()
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.page = 1
            this.getData();
        },
        // 获取列表
        getData() {
            var type = 1
            if (this.active == 1) {
                type = 0
            }
            var params = {
                token: this.token,
                type: type,
                page: this.page,
                size: this.size
            }
            this.$api.seller.centerGoods(params).then(res => {
                if (res.code == 200) {
                    if (res.result && res.result.list && res.result.list.good) {
                        var list = res.result.list.good
                        var old = this.goodsList
                        if (this.page == 1) {
                            old = []
                        }
                        for (let i = 0; i < list.length; i++) {
                            list[i].checked = true
                            old.push(list[i])
                        }
                        this.goodsList = old
                        if (list.length < this.size) {
                            // 数据全部加载完
                            this.finished = true
                            this.refreshing = false
                            return;
                        }
                    } else {
						this.finished = true
                    }

                } else {
                    this.finished = true
                    this.$toast(res.message)
                }
                this.page++;
                this.refreshing = false
                this.loading = false;
            })
        },
        // 下架单条商品
        dropGoods(goods) {
            var arr = []
            console.log('goods.checked', goods.checked)
            // 选中再下架
            if (goods.checked) {
                arr.push(goods.good_id)
            } else {
                this.$toast('请先选择商品')
                return
            }
            var params = {
                token: this.token,
                sids: arr
            }
            console.log('下架', params.sids)
            this.$api.tradesman.drop(params).then(res => {
                if (res.code == 200) {
                    this.onRefresh()
                    this.$toast('下架成功')
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 上架单条商品
        onGoods(goods) {
            var arr = []
            // 选中再上架
            if (goods.checked) {
                arr.push(goods.good_id)
            } else {
                this.$toast('请先选择商品')
                return
            }
            var params = {
                token: this.token,
                sids: arr,
                // starttime: '2020-4-23',
                // endtime: '2050-4-21'
            }
            if (!this.starttime || !this.endtime) {
                this.$toast('请先选择时间')
                return
            } else if (new Date(this.starttime) > new Date(this.endtime)) {
                this.$toast('请配置合法时间')
                return
            } else {
                params.starttime = this.starttime
                params.endtime = this.endtime
            }
            console.log('上架', params)
            this.$api.tradesman.on(params).then(res => {
                if (res.code == 200) {
                    this.onRefresh()
                    this.$toast('上架成功')
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 选某个商品 改变其选择状态
        checkGood(goods) {
            for (var i in this.goodsList) {
                if (this.goodsList[i].good_id == goods.good_id) {
                    this.goodsList[i].checked = !goods.checked
                }
            }
            var zhuangtai = true
            console.log('this.goodsList', this.goodsList)
            for (var j in this.goodsList) {
                if (!this.goodsList[j].checked) {
                    zhuangtai = false
                }
            }
            this.checkedAll = zhuangtai
        },
        // 全选
        clickAllCheck() {
            var zhuangtai = true
            if (this.checkedAll) {
                zhuangtai = false
            }
            if (zhuangtai) {
                for (var i in this.goodsList) {
                    this.goodsList[i].checked = true
                }
            }
            if (!zhuangtai) {
                for (var i in this.goodsList) {
                    this.goodsList[i].checked = false
                }
            }
            this.checkedAll = zhuangtai
            console.log('全选', this.checkedAll)
            // console.log('this.goodsList',this.goodsList)
        },
        // 批量下架
        dropAllGoods() {
            console.log('批量下架')
            console.log('this.goodsList', this.goodsList)
            var arr = []
            for (var i in this.goodsList) {
                if (this.goodsList[i].checked) {
                    arr.push(this.goodsList[i].good_id)
                }
            }
            var params = {
                token: this.token
            }
            if (arr.length != 0) {
                params.sids = arr
            } else {
                this.$toast('请选择商品')
                return
            }
            console.log('params', params)
            this.$api.tradesman.drop(params).then(res => {
                if (res.code == 200) {
                    this.onRefresh()
                    this.$toast('下架成功')
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 批量上架
        onAllGoods() {
            console.log('批量上架')
            console.log('this.goodsList', this.goodsList)
            var arr = []
            for (var i in this.goodsList) {
                if (this.goodsList[i].checked) {
                    arr.push(this.goodsList[i].good_id)
                }
            }
            var params = {
                token: this.token
            }
            if (arr.length != 0) {
                params.sids = arr
            } else {
                this.$toast('请选择商品')
                return
            }
            if (!this.starttime || !this.endtime) {
                this.$toast('请先选择时间')
                return
            } else if (new Date(this.starttime) > new Date(this.endtime)) {
                this.$toast('请配置合法时间')
                return
            } else {
                params.starttime = this.starttime
                params.endtime = this.endtime
            }

            console.log('params', params)
            this.$api.tradesman.on(params).then(res => {
                if (res.code == 200) {
                    this.onRefresh()
                    this.$toast('上架成功')
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 加上上架商品时的时间选择 -- 单个商品上架
        onUpSingleGoods(goods) {
            this.show = true
            this.starttime = ''
            this.endtime = ''
            this.goods = goods
            this.goods_tag = 0
        },
        // 加上上架商品时的时间选择 -- 批量商品上架
        onUpAllGoods() {
            this.show = true
            this.starttime = ''
            this.endtime = ''
            this.goods_tag = 1
        },
        // 确认时间选择
        confirmOnGoods() {
            this.show = false
            console.log('上架时间', this.starttime)
            console.log('下架时间', this.endtime)
            if (this.goods_tag == 0) {
                this.onGoods(this.goods)
            } else if (this.goods_tag == 1) {
                this.onAllGoods()
            }
        },
        onTimepicker(type) {
            this.timepicker = true
            this.timeType = type
        },
        confirmTime(value) {
            console.log('confirmTime', value)
            if (this.timeType == 0) {
                this.starttime = this.formatDate(value)
            } else if (this.timeType == 1) {
                this.endtime = this.formatDate(value)
            }
            this.timepicker = false
        },
        formatDate(date) {
            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString();
			var day = date.getDate().toString();
			var hour = date.getHours().toString()
			var minutes = date.getMinutes().toString()
			var seconds = date.getSeconds().toString()
            if (month.length == 1) {
                month = '0' + month;
            }
            if (day.length == 1) {
                day = '0' + day;
			}
			if (hour.length == 1) {
                hour = '0' + hour;
			}
			if (minutes.length == 1) {
                minutes = '0' + minutes;
			}
			if (seconds.length == 1) {
                seconds = '0' + seconds;
			}
            return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/deep/.van-cell .van-field__control {
    color: #000;
}
/deep/.van-dialog__content .title{
	width: 100%;
	padding: .2rem 0;
	text-align: center;
	font-size: .4rem;
}
/deep/.van-dialog__content .van-cell-group .van-cell{
	padding: .1rem .53rem;
}
</style>
